import { render, staticRenderFns } from "./IconPencilAltOutline.vue?vue&type=template&id=424add42"
import script from "./IconPencilAltOutline.vue?vue&type=script&lang=js"
export * from "./IconPencilAltOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports